// eslint-disable-next-line import/prefer-default-export
export const STATUSES_CONSTANTS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  SUCCESS: 'success',
  FAILURE: 'failure',
  AMENDED: 'amended',
};
